import { configureStore } from "@reduxjs/toolkit";
import configSlice from "./slice/configSlice.js";
import userSlice from "./slice/userSlice.js";
import applicationSlice from "./slice/applicationSlice.js";
import assetSlice from "./slice/assetSlice.js";
import tagsSlice from "./slice/tagsSlice.js";

export const store = configureStore({
  reducer: {
    configSlice,
    userSlice,
    applicationSlice,
    assetSlice,
    tagsSlice,
  },
});
